<template>
  <div id="container">
    <div class="product-status">
      <div class="bold"></div>
      <el-tabs v-model="activeName" @tab-click="handleClick(activeName)">
        <el-tab-pane
          :label="item.title"
          :name="item.name"
          class="tab-text"
          v-for="(item, index) in waitFeedbackEnquiryTabs"
          :key="index"
        >
          <!------------------ 搜索条件 ---------------->
          <search-purchase-list
            @searchFor="searchFor"
            @searchReset='searchReset'
            @showAllList="showAllList"
            :activeName="activeName"
          ></search-purchase-list>
          <!------------------ 待采购table ---------------->
          <wait-procurement-area-list
            v-show="activeName ==='待采购'"
            :total="total"
            :currentPage="currentPage"
            :pageSize="pageSize"
            @waitMoveList="waitMoveList"
            @toExport='toExport'
            :dataList="waitPurchase"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
          ></wait-procurement-area-list>
          <!------------------ 采购执行去table ---------------->
          <procurement-area-list @onRefresh='onRefresh' v-show="activeName ==='待采购'" :dataList="usedPurchase"></procurement-area-list>
          <purchase-plan-list-data
            v-show="activeName !=='待采购'"
            :activeName="activeName"
            :currentPage="currentPage"
            :pageSize="pageSize"
            :tableHeight="tableHeight"
            :total="total"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
            :dataList="purchaseList"
          ></purchase-plan-list-data>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { planListTabs } from './util/data'
import waitProcurementAreaList from './components/distribution/waitProcurementAreaList'
import searchPurchaseList from './components/distribution/searchPurchaseList'
import procurementAreaList from './components/distribution/procurementAreaList'
import purchasePlanListData from './components/distribution/purchasePlanListData'
import { downLoadFileBlob } from '@/util/tool'
import {
  queryByOrderContractStockupPurchase, StockCoeDerive

} from '@/api/purchase/purchaseManage'
import { deepClone } from '@/util'

import {
  queryPurchaseContractBaseByOcsp
} from '@/api/purchase/purchasePlanList'

export default {
  components: {
    'wait-procurement-area-list': waitProcurementAreaList, // 待采购table
    'procurement-area-list': procurementAreaList, // 采购执行去table
    'search-purchase-list': searchPurchaseList, // 搜索条件
    'purchase-plan-list-data': purchasePlanListData// 列表
  },

  data () {
    return {
      activeName: '待采购',
      purchaseList: [], // 其他列表
      waitPurchase: [], // 上面列表
      usedPurchase: [], // 下面列表
      waitFeedbackEnquiryTabs: planListTabs, // tabs状态
      loadingTable: false, // 列表loading
      currentPage: 1, // 页码
      pageSize: 30,
      total: 0, // 列表总数
      content: '',
      title: '',
      params: [],
      paramsList: [],
      array: [],
      state: 1,
      tableHeight: window.innerHeight,
      queryParams: {}

    }
  },

  mounted () {
    this.getList()
  },
  watch: {
    usedPurchase: {
      handler (newVal) {
        this.array = []
        this.usedPurchase.forEach(element => {
          if (element.stockupCount === element.count) {
            this.array.push(element.ocspId)
          }
        })
        this.getList()
      },
      deep: true
    }
  },
  methods: {
    // 导入产品返回更新列表
    onRefresh(data) {
      this.waitMoveList(data)
    },
    showAllList (showAll) {
      if (this.activeName === '采购审核') {
        if (showAll) {
          this.tableHeight = window.innerHeight - 492
        } else {
          this.tableHeight = window.innerHeight - 445
        }
      } else {
        if (showAll) {
          this.tableHeight = window.innerHeight - 541
        } else {
          this.tableHeight = window.innerHeight - 445
        }
      }
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    },
    searchFor (data, timeValue, timeEndValue) {
      this.params = []
      this.paramsList = []
      for (const key in data) {
        const queryParams = {}
        queryParams.column = key
        queryParams.value = data[key]
        this.params.push(queryParams)
        this.queryParams = queryParams
      }
      if (this.activeName === '待采购') {
        if (timeValue) {
          const queryParams = {}
          queryParams.column = 'deliveryTime'
          queryParams.value = timeValue
          queryParams.endValue = timeEndValue
          this.queryParams = queryParams
          this.params.push(queryParams)
          this.paramsList = deepClone(this.params)
          this.pageSize = 30
          this.currentPage = 1
          this.getList()
        } else {
          this.paramsList = deepClone(this.params)
          this.pageSize = 30
          this.currentPage = 1
          this.getList()
        }
      } else {
        if (timeValue) {
          const queryParams = {}
          queryParams.column = 'signDate'// 签订时间
          queryParams.value = timeValue
          queryParams.endValue = timeEndValue

          this.params.push(queryParams)
          this.paramsList = deepClone(this.params)
          this.pageSize = 30
          this.currentPage = 1
          this.getList()
        } else {
          this.paramsList = deepClone(this.params)
          this.pageSize = 30
          this.currentPage = 1
          this.getList()
        }
      }
    },
    searchReset() {
      this.queryParams = {}
      this.params = []
      this.paramsList = []
      this.pageSize = 30
      this.currentPage = 1
      this.getList()
    },
    // 移入采购区
    waitMoveList (value) {
      if (this.usedPurchase.length !== 0) {
        if (this.usedPurchase[0].stockupType === '直发备货') {
          let isTrue = false
          value.forEach(element => {
            if (this.usedPurchase[0].stockupType === element.stockupType && this.usedPurchase[0].storageName === element.storageName) {
              value.forEach(element => {
                let isFalse = false
                this.usedPurchase.forEach(ele => {
                  if (element.ocspId === ele.ocspId) {
                    ele.stockupCount = ele.count
                    isFalse = true
                  }
                })
                if (!isFalse) {
                  console.log('2222')
                  this.usedPurchase.push(element)
                }
              })
            } else {
              if (!isTrue) {
                console.log('8888')
                this.$message.error('所选产品不可同时移入采购区！')
                isTrue = true
              }
            }
          })
        } else {
          let isTrue = false
          value.forEach(element => {
            if (this.usedPurchase[0].stockupType === element.stockupType && this.usedPurchase[0].storageName === element.storageName) {
              value.forEach(element => {
                let isFalse = false
                this.usedPurchase.forEach(ele => {
                  if (element.ocspId === ele.ocspId) {
                    ele.stockupCount = ele.count
                    isFalse = true
                  }
                })
                if (!isFalse) {
                  this.usedPurchase.push(element)
                }
              })
            } else {
              if (!isTrue) {
                this.$message.error('所选产品不可同时移入采购区！')
                isTrue = true
              }
            }
          })
        }
      } else {
        let isFalse = false
        value.forEach((element, index) => {
          value.forEach((ele, indexs) => {
            if (!(ele.stockupType === element.stockupType && ele.storageName === element.storageName) && !isFalse && index !== indexs) {
              this.$message.error('所选产品不可同时移入采购区！')
              isFalse = true
            }
          })
        })
        if (!isFalse) {
          this.usedPurchase = value
        }
      }
    },
    toExport() {
      const orderPurchaseSearchVo = {}
      const params = {
        criteriaVoList: [this.queryParams],
        queryPageName: ''
      }
      const queryParams = {}
      queryParams.queryCriteriaVo = params
      queryParams.ocspIds = this.array.toString()
      orderPurchaseSearchVo.orderPurchaseSearchVo = queryParams
      orderPurchaseSearchVo.templateUrl = this.$store.state.purchasePlanListUrl
      StockCoeDerive(orderPurchaseSearchVo)
        .then(res => {
          downLoadFileBlob(this, res)
        })
        .catch(err => {
          console.log(err)
        })
    },
    getList () {
      if (this.activeName === '待采购') {
        const params = {
          criteriaVoList: this.paramsList,
          queryPageName: ''
        }
        const queryParams = {}
        queryParams.queryCriteriaVo = params
        queryParams.ocspIds = this.array.toString()
        queryByOrderContractStockupPurchase(this.currentPage, this.pageSize, queryParams)
          .then((res) => {
            if (res.data.code === 200) {
              this.waitPurchase = res.data.obj.records
              this.total = res.data.obj.total
              this.waitPurchase.forEach(element => {
                this.usedPurchase.forEach(ele => {
                  if (element.ocspId === ele.ocspId) {
                    element.stockupCount = element.stockupCount - ele.stockupCount
                  }
                })
              })
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        const params = {
          criteriaVoList: this.paramsList,
          queryPageName: ''
        }

        if (this.activeName === '采购审核') {
          this.state = 1
        } else if (this.activeName === '采购中') {
          this.state = 2
        } else if (this.activeName === '已采购') {
          this.state = 3
        }
        queryPurchaseContractBaseByOcsp(this.state, this.currentPage, this.pageSize, params)
          .then((res) => {
            if (res.data.code === 200) {
              this.purchaseList = res.data.obj.records
              this.total = res.data.obj.total
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    // tabs切换时触发的事件
    handleClick (activeName) {
      this.currentPage = 1 // 页码
      this.pageSize = 30
      this.params = []
      this.usedPurchase = []
      this.paramsList = []
      this.tableHeight = window.innerHeight - 445
      this.getList()
    }

  }
}

</script>
<style lang="scss" scoped>
</style>
